import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Target, EnvelopeSimple } from "@phosphor-icons/react";
import { API } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/auth/creator/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="grain absolute inset-0 pointer-events-none" />
      <div className="w-full max-w-md relative">
        <Link to="/creator/login" className="kbd-label text-white/50 hover:text-neon-cyan">← BACK TO SIGN IN</Link>
        <div className="card-tactical p-8 mt-4">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 bg-neon-yellow flex items-center justify-center">
              <Target size={22} weight="bold" color="#050505" />
            </div>
            <div>
              <div className="kbd-label text-neon-yellow">CREATOR PORTAL</div>
              <h1 className="display-heading font-black text-2xl">Forgot Password</h1>
            </div>
          </div>

          {sent ? (
            <div data-testid="forgot-sent-message" className="space-y-4">
              <div className="w-12 h-12 bg-neon-cyan/10 border border-neon-cyan/40 flex items-center justify-center">
                <EnvelopeSimple size={24} color="#22d3ee" weight="fill" />
              </div>
              <p className="text-white/80 text-sm leading-relaxed">
                If an account with that email exists, we've sent a password reset link to it.
                Check your inbox (and spam folder) and follow the link within 60 minutes.
              </p>
              <Link to="/creator/login" data-testid="forgot-back-btn" className="neon-btn w-full py-3 inline-flex items-center justify-center">
                RETURN TO SIGN IN
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <p className="text-white/60 text-sm leading-relaxed">
                Enter the email on your creator account and we'll send you a link to reset your password.
              </p>
              <div>
                <div className="kbd-label mb-2">EMAIL</div>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="forgot-email-input"
                  className="w-full bg-black/60 border border-white/10 px-4 py-3 font-mono text-sm focus:outline-none focus:border-neon-cyan"
                  placeholder="you@example.com"
                />
              </div>
              <button
                type="submit"
                disabled={busy}
                data-testid="forgot-submit-btn"
                className="neon-btn w-full py-3 mt-2 disabled:opacity-50 inline-flex items-center justify-center gap-2"
              >
                {busy ? "SENDING…" : "SEND RESET LINK"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
